import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

const Spinner = () => (
    <div className="spinner">
        <ThreeDots
            height="100"
            width="100"
            color="#0052cc"
            visible={true}
        />
    </div>
);

export default Spinner;